__turbopack_context__.v({
  "hitSwatches": "Swatches-module-scss-module__4NGqya__hitSwatches",
  "overflowToggle": "Swatches-module-scss-module__4NGqya__overflowToggle",
  "swatchButton": "Swatches-module-scss-module__4NGqya__swatchButton",
  "swatchButtonActive": "Swatches-module-scss-module__4NGqya__swatchButtonActive",
  "swatchButtonColourNotAvailable": "Swatches-module-scss-module__4NGqya__swatchButtonColourNotAvailable",
  "swatchFallback": "Swatches-module-scss-module__4NGqya__swatchFallback",
  "swatchImage": "Swatches-module-scss-module__4NGqya__swatchImage",
  "swatchWrapper": "Swatches-module-scss-module__4NGqya__swatchWrapper",
  "swatchesOpen": "Swatches-module-scss-module__4NGqya__swatchesOpen",
});
